import { render, staticRenderFns } from "./BtnInserirRateioRequisicao.vue?vue&type=template&id=9011ff28"
import script from "./BtnInserirRateioRequisicao.vue?vue&type=script&lang=js"
export * from "./BtnInserirRateioRequisicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports